const str = location.host;
let domain = ''; // sdk服务的baseurl
let tsMainDomain = ''; // 中台服务baseurl
let axiosBaseUrl = ''; // axio baseUrl
let wsDomain = ''; // websocket url
let wsCustomerDomain = ''; // websocket url
if (str) {
  if (str.startsWith('localhost')) {
    domain = '//localhost:8083/';
    tsMainDomain = '//172.18.117.71:8080/';
    axiosBaseUrl = '';
    wsDomain = 'ws://172.18.117.71:31430/ws';
    wsCustomerDomain = 'ws://172.18.117.71:31638/ws-customer';
  } else {
    const protocol = location.protocol;
    domain = `//${str}`;
    tsMainDomain = `${location.protocol}//${str}/`;
    axiosBaseUrl = ''; // 请求接口要加ea-workbench前缀，会在域名nginx中去除ea-workbench前缀并转发到项目nginx中
    if (protocol === 'https:') {
      wsDomain = `wss://${str}/dn-workbench/ws`;
      wsCustomerDomain = `wss://${str}/dn-workbench/ws-customer`;
    } else {
      wsDomain = `ws://${str}/dn-workbench/ws`;
      wsCustomerDomain = `ws://${str}/dn-workbench/ws-customer`;
    }
  }
}

export { domain, tsMainDomain, axiosBaseUrl, wsDomain, wsCustomerDomain };
